import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from "@angular/core";
import {CdkVirtualScrollViewport} from "@angular/cdk/scrolling";
import {GroupModel} from "../../../models/group.model";

require('./groups-table.scss');
@Component({
  standalone: false,
  selector: 'app-groups-table',
  templateUrl: './groups-table.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GroupsTableComponent implements OnInit, OnChanges {

  @Input() groups: GroupModel[];
  @Input() sortType: any;
  @Input() allowEdit: boolean;
  @Input() allowDelete: boolean;
  @Input() allowSort: boolean;
  @Output() reloadEvent = new EventEmitter<any>();
  @Output() fetchNextEvent = new EventEmitter<null>();
  @Output() editGroupEvent = new EventEmitter<GroupModel>();
  @Output() deleteGroupEvent = new EventEmitter<GroupModel>();
  @Output() sortTypeChangeEvent = new EventEmitter<string>();

  @ViewChild(CdkVirtualScrollViewport, {static: false})
  private cdkVirtualScrollViewport: CdkVirtualScrollViewport;

  public currentLastRowIndex: number;
  public asceDescIconsMap: any;

  constructor() {
  }

  ngOnInit() {
    this.asceDescIconsMap = {
      asc: 'sort-asc',
      desc: 'sort-desc',
      undefined: 'sort'
    };
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.groups && this.groups.length) {
      this.cdkVirtualScrollViewport?.checkViewportSize();
    }
  }

  getNextBatch() {
    if (this.cdkVirtualScrollViewport.measureScrollOffset('bottom') < 50) {
      this.fetchNextEvent.emit();
    }
  }


}
